import { whiteColor } from 'assets/jss/material-dashboard-pro-react';
const errorPageStyle = (theme) => ({
	contentCenter: ({ isNewDashBoardEnabled }) => ({
		textAlign: 'left',
		width: '100%',
		padding: '48px 64px',
		margin: '0 auto',
		maxWidth: '880px',
		background: whiteColor,
		borderRadius: '8px',
		[theme.breakpoints.up('md')]: {
			...(isNewDashBoardEnabled
				? {}
				: { position: 'absolute', top: '46%', left: '50%', zIndex: '3', transform: 'translate(-50%,-50%)' }),
		},
	}),
	image: {
		maxWidth: '100px',
	},
	error: {
		paddingTop: '30px',
		[theme.breakpoints.down('xs')]: {
			paddingTop: '24px',
		},
	},
	errorTitle: {
		fontSize: theme.fontSize(40),
		fontFamily: theme.fontFamily.albert.bold,
		lineHeight: '40px',
	},
	errorDescription: {
		fontSize: theme.fontSize(18),
		fontFamily: theme.fontFamily.albert.regular,
		lineHeight: '24px',
	},
	returnHome: {
		fontSize: theme.fontSize(18),
		fontFamily: theme.fontFamily.albert.regular,
		padding: '14px 16px',
		textTransform: 'initial',
		marginTop: '16px',
		color: whiteColor,
	},
});

export default errorPageStyle;
